import { render, staticRenderFns } from "./SoundList.vue?vue&type=template&id=15a9aa3a&scoped=true&"
import script from "./SoundList.vue?vue&type=script&lang=js&"
export * from "./SoundList.vue?vue&type=script&lang=js&"
import style0 from "./SoundList.vue?vue&type=style&index=0&id=15a9aa3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9aa3a",
  null
  
)

export default component.exports